/* eslint-disable no-underscore-dangle */
export const sendDataToAnalytics = (...rest) => {
  if (typeof _paq !== 'undefined') {
    window._paq.push(['trackEvent', ...rest]);
  }
};
